import { useEffect, useRef, useState } from "react";
import { formatPhoneForZoom } from "utils/phone";
import { showErrorToast } from "utils/toast";

const ZoomPhoneEmbed = ({ phoneNumber, handleCallEnd, handleCallStart }) => {
  const iframeRef = useRef(null);
  const processedCallIds = useRef(new Set());
  const [isIframeReady, setIsIframeReady] = useState(false);

  useEffect(() => {
    const originDomain = window.location.origin.includes("localhost")
      ? "https://dev.emc-portal.com"
      : window.location.origin;

    const iframe = document.createElement("iframe");
    iframe.src = `https://applications.zoom.us/integration/phone/embeddablephone/home?originDomain=${originDomain}`;

    iframe.id = "zoom-embeddable-phone-iframe";
    iframe.allow =
      "clipboard-read; clipboard-write https://applications.zoom.us";
    iframe.style.display = "block";
    iframe.style.position = "fixed";
    iframe.style.bottom = "20px";
    iframe.style.right = "20px";
    iframe.style.width = "400px";
    iframe.style.height = "600px";
    iframe.style.zIndex = "9999";
    iframe.style.borderRadius = "12px";
    iframe.style.boxShadow = "0 4px 20px rgba(0,0,0,0.3)";
    iframe.style.background = "#fff";
    document.body.appendChild(iframe);

    iframeRef.current = iframe;

    iframe.onload = () => {};

    const handleMessage = (event) => {
      try {
        if (event.origin !== "https://applications.zoom.us") return;
        const msg = event.data;

        if (msg?.type === "zp-init" || msg?.type === "zp-ready") {
          setIsIframeReady(true);
        }

        if (msg.type === "zp-call-ringing-event") {
          const { dateTime } = msg.data || {};
          handleCallStart(dateTime);
        }

        const currentPhoneNumber = formatPhoneForZoom(phoneNumber);
        const calleeNumber = msg?.data?.callee;
        const calleeDidNumber = formatPhoneForZoom(
          calleeNumber?.didNumber ||
            calleeNumber?.number ||
            calleeNumber?.phoneNumber ||
            ""
        );

        if (
          msg.type === "zp-call-log-completed-event" &&
          currentPhoneNumber === calleeDidNumber
        ) {
          const {
            callId,
            result: callStatus,
            dateTime: callEndAt,
            duration,
          } = msg.data || {};

          if (processedCallIds.current.has(callId)) return;
          processedCallIds.current.add(callId);

          handleCallEnd({
            callId,
            callEndAt,
            callStatus:
              duration === 0 ? "could not connect" : callStatus.toLowerCase(),
          });
        }
      } catch (error) {
        showErrorToast(error.message);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      iframe.remove();
    };
  }, []);

  useEffect(() => {
    if (isIframeReady && phoneNumber && iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(
        { type: "zp-make-call", data: { number: phoneNumber } },
        "https://applications.zoom.us"
      );

      const iframeHeight = 600;
      const iframeBottom = 20;
      const iframeRight = 20;

      const closeBtn = document.createElement("button");
      closeBtn.innerText = "×";
      closeBtn.style.position = "fixed";
      closeBtn.style.zIndex = "10000";
      closeBtn.style.width = "30px";
      closeBtn.style.height = "30px";
      closeBtn.style.background = "red";
      closeBtn.style.color = "#fff";
      closeBtn.style.border = "none";
      closeBtn.style.borderRadius = "50%";
      closeBtn.style.cursor = "pointer";
      closeBtn.style.fontSize = "20px";
      closeBtn.style.lineHeight = "30px";

      closeBtn.style.bottom = `${iframeBottom + iframeHeight - 10}px`;
      closeBtn.style.right = `${iframeRight - 5}px`;

      closeBtn.onclick = () => {
        iframeRef.current.style.display = "none";
        closeBtn.remove();
      };

      document.body.appendChild(closeBtn);
    }
  }, [isIframeReady, phoneNumber]);

  return null;
};

export default ZoomPhoneEmbed;
